import { httpClient } from './httpClient'
import type { ContactMessageDto, CreateContactMessageRequest } from '../dto/admin/ContactMessageDto'

export const contactMessageApi = {
  create: (request: CreateContactMessageRequest) => httpClient.post<ContactMessageDto>('/contact-messages', request),
}
